<template>
  <app-layout>
    <WeekShopIndex/>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import WeekShopIndex from '@/Components/WeekShop/WeekShopIndex.vue'

export default {
  name: 'WeekOrderIndex',
  components: { AppLayout, WeekShopIndex }
}
</script>
